export const GervaisSpriteNames = {
    ///////////////////////////////////////////////////////
    // Damage Effects
    ///////////////////////////////////////////////////////

    DAMAGE_EFFECT_NAME_RED_SPLAT : 'Red Splat',
    DAMAGE_EFFECT_NAME_RED_DAMAGE : 'Red Damage',
    DAMAGE_EFFECT_NAME_WHITE_DAMAGE : 'White Damage',
    DAMAGE_EFFECT_NAME_BLUE_DAMAGE : 'Blue Damage',
    DAMAGE_EFFECT_NAME_GREEN_DAMAGE : 'Green Damage',
    DAMAGE_EFFECT_NAME_SHOCK_DAMAGE : 'Electric Damage',
    DAMAGE_EFFECT_NAME_FIRE_DAMAGE : 'Fire Damage',
    DAMAGE_EFFECT_NAME_POISON_DAMAGE : 'Poison Damage',
    DAMAGE_EFFECT_NAME_SONIC_DAMAGE : 'Sonic Damage',
    DAMAGE_EFFECT_NAME_PINK_DAMAGE : 'Pink Damage',

    ///////////////////////////////////////////////////////
    // Missiles
    ///////////////////////////////////////////////////////

    MISSILE_EFFECT_NAME_ARROW : 'Red Arrow',
    MISSILE_EFFECT_NAME_FAT_ARROW : 'Fat Red Arrow',
    MISSILE_EFFECT_NAME_GREEN_ARROW : 'Green Arrow',
    MISSILE_EFFECT_NAME_PINK_ARROW : 'Pink Arrow',
    MISSILE_EFFECT_NAME_ARROW_WALL : 'Wall Arrow',
    MISSILE_EFFECT_NAME_SPEAR : 'Spear',
    MISSILE_EFFECT_NAME_PINK_LIGHTNING : 'Pink Lightning',
    MISSILE_EFFECT_NAME_GREEN_PROJECTILE : 'Green Projectile',
    MISSILE_EFFECT_NAME_SMALL_GREEN_PROJECTILE : 'Small Green Projectiles',
    MISSILE_EFFECT_NAME_FIRE_PROJECTILE : 'Fire Projectile',
    MISSILE_EFFECT_NAME_FIRE_ARROW : 'Fire Arrow',
    MISSILE_EFFECT_NAME_ICE_PROJECTILE : 'Ice Projectile',
    MISSILE_EFFECT_NAME_ICE_ARROW : 'Ice Arrow',
    MISSILE_EFFECT_NAME_LIGHTNING : 'Lightning',
    MISSILE_EFFECT_NAME_LIGHTNING_ARROW : 'Lightning Arrow',
    MISSILE_EFFECT_NAME_GREY_BULLET : 'Grey Bullet',
    MISSILE_EFFECT_NAME_YELLOW_BULLET : 'Yellow Bullet',
    MISSILE_EFFECT_NAME_NINJA_STAR : 'Ninja Star',
    MISSILE_EFFECT_NAME_WEB : 'Web',
    MISSILE_EFFECT_NAME_PINK_STAR_PROJECTILE : 'Pink Star Projectile',
    MISSILE_EFFECT_NAME_PINK_BALL_PROJECTILE : 'Pink Ball Projectile',
    MISSILE_EFFECT_NAME_YELLOW_STAR_PROJECTILE : 'Yellow Star Projectile',


    ///////////////////////////////////////////////////////
    // Spell Effects: SpellFXAnim1
    ///////////////////////////////////////////////////////

    EFFECT_NAME_SPARKLE_GOLD : 'Gold Sparkles',
    EFFECT_NAME_SPARKLE_GREEN : 'Green Sparkles',
    EFFECT_NAME_SPARKLE_BLUE : 'Blue Sparkles',
    EFFECT_NAME_SPARKLE_ORANGE : 'Orange Sparkles',
    EFFECT_NAME_SPARKLE_PINK : 'Pink Sparkles',
    EFFECT_NAME_SPARKLE_RED : 'Red Sparkles',
    EFFECT_NAME_GREEN_SKULL : 'Green Skull',
    EFFECT_NAME_YELLOW_KEY : 'Yellow Key',
    EFFECT_NAME_SKULL_CROSS : 'Skull Cross',
    EFFECT_NAME_SHIELDS : 'Shields',
    EFFECT_NAME_RED_CROSSES : 'Red Crosses',
    EFFECT_NAME_FIRE_RING : 'Fire Ring',
    EFFECT_NAME_ICE_RING : 'Ice Ring',
    EFFECT_NAME_GREEN_RING : 'Green Ring',
    EFFECT_NAME_PINK_RING : 'Pink Ring',
    EFFECT_NAME_YELLOW_STAR : 'Yellow Star',
    EFFECT_NAME_BLUE_STAR : 'Blue Star',
    EFFECT_NAME_GREEN_STAR : 'Green Star',
    EFFECT_NAME_WEB : 'Spider Web',
    EFFECT_NAME_WHITE_CROSSES : 'White Crosses',
    EFFECT_NAME_TORCH : 'Torch',

    ///////////////////////////////////////////////////////
    // Spell Effects: SpellFXAnim2
    ///////////////////////////////////////////////////////

    EFFECT_NAME_FROST : 'Frost',
    EFFECT_NAME_YELLOW_STAR_CIRCLE : 'Yellow Star Circle',
    EFFECT_NAME_CIRCLES : 'Circles',
    EFFECT_NAME_GOLD_SHIELD_SPIRAL : 'Gold Shield Spiral',
    EFFECT_NAME_GREEN_SHIELD_SPIRAL : 'Green Shield Spiral',
    EFFECT_NAME_BLUE_SHIELD_SPIRAL : 'Blue Shield Spiral',
    EFFECT_NAME_PINK_SHIELD_SPIRAL : 'Pink Shield Spiral',
    EFFECT_NAME_BLUE_FIREWORK : 'Blue Firework',
    EFFECT_NAME_RED_FIREWORK : 'Red Firework',
    EFFECT_NAME_BUBBLES : 'Bubbles',


    ///////////////////////////////////////////////////////
    // Spell Effects: SpellFXAnim3
    ///////////////////////////////////////////////////////

    EFFECT_NAME_SHIELD : 'Shield',
    EFFECT_NAME_COLOR_SPIRAL : 'Color Spiral',
    EFFECT_NAME_ARM_FLEX : 'Arm Flex',
    EFFECT_NAME_SUPER_SPEED : 'Super Speed',
    EFFECT_NAME_TARGET : 'Target',
    EFFECT_NAME_YELLOW_SHIELD_SPIRAL : 'Yellow Shield Spiral',
    EFFECT_NAME_PINK_STAR_CIRCLE : 'Pink Star Circle',
    EFFECT_NAME_BLUE_STAR_CIRCLE : 'Blue Star Circle',
    EFFECT_NAME_GREEN_STAR_CIRCLE : 'Green Star Circle',
    EFFECT_NAME_GOLD_STAR_CIRCLE : 'Gold Star Circle',
    EFFECT_NAME_BREAD : 'Bread',

    ///////////////////////////////////////////////////////
    // Spell Effects: SpellFXAnim4
    ///////////////////////////////////////////////////////

    EFFECT_NAME_YELLOW_FIRE_RING : 'Yellow Fire Ring',
    EFFECT_NAME_TOTEMS : 'Totems',
    EFFECT_NAME_EYE_BLINK : 'Eye Blink',
    EFFECT_NAME_PINK_STAR : 'Pink Star',
    EFFECT_NAME_ORANGE_STAR : 'Orange Star',
    EFFECT_NAME_RED_EYE_BLINK : 'Red Eye Blink',
    EFFECT_NAME_EAGLE : 'Eagle',
    EFFECT_NAME_SLEEP : 'Sleep',
    EFFECT_NAME_ARMOR : 'Armor',
    EFFECT_NAME_BLIND_EYE_BLINK : 'Blind Eye Blink',
    EFFECT_NAME_FIRE_RAIN : 'Fire Rain',
    EFFECT_NAME_BLUE_RAIN : 'Blue Rain',
    EFFECT_NAME_GREEN_RAIN : 'Green Rain',

    ///////////////////////////////////////////////////////
    // Spell Effects: SpellFXAnim5
    ///////////////////////////////////////////////////////

    EFFECT_NAME_LIGHTNING_RAIN : 'Lightning Rain',
    EFFECT_NAME_PINK_RAIN : 'Pink Rain',
    EFFECT_NAME_RAINBOW_RAIN : 'Rainbow Rain',

};